import { FC, useRef } from "react";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";
import { useClickOutOfElement } from "../../../custom-hooks/base-hooks/useClickOutOfElement";

interface AutocompleteTooltipProps {
    data: string[];
    resetCallback: () => void;
    selectCallback: (value: string) => void;
    className?: string;
}

const AutocompleteTooltip: FC<AutocompleteTooltipProps> = (props) => {
    const { upTo1024 } = useScreenSize();
    const tooltipRef = useRef<HTMLDivElement>();

    useClickOutOfElement(tooltipRef, () => {
        props.resetCallback();
    });

    if (!props.data.length) {
        return <></>;
    }

    return (
        <div ref={tooltipRef} className="relative flex items-center cursor-pointer group">
            <div
                className={`
                    absolute top-2 pb-3 z-10
                    flex flex-col gap-3 dmax2:gap-2 items-center justify-center
                    bg-backgroundInput w-full dmin2:py-4 dmax2:pt-4
                    rounded-[7px] transition duration-300
                    ${props.className}
                `}
            >
                {props.data.map((text, index) => (
                    <div
                        onClick={() => {
                            props.selectCallback(text);
                            props.resetCallback();
                        }}
                        key={"autocompleted_text_" + text}
                        className={`
                            flex justify-start items-center
                            H16 dmax2:H14 pl-4
                            text-textWhite text-center
                            w-full h-[${upTo1024 ? "32" : "45"}px]
                            truncate whitespace-nowrap
                            hover:font-[500] cursor-pointer
                            hover:bg-textFaded
                            ${upTo1024 ? "" : "rounded-md"}
                            ${upTo1024 && index !== props.data.length - 1 ? "border-b border-textFaded" : ""}
                            transition-all duration-300
                        `}
                    >
                        {text}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AutocompleteTooltip;
